




















import { Component, Vue } from 'vue-property-decorator'
import { ExStore } from 'vuex'

@Component({
  components: {
    WorkerInfoForm: () =>
      import('@/components/accountSetting/WorkerInfoForm.vue'),
    TabSettingForm: () =>
      import('@/components/accountSetting/TabSettingForm.vue')
  }
})
export default class AccountSetting extends Vue {
  $store!: ExStore

  get workerInfo() {
    return this.$store.getters['user/workerInfo']
  }

  get occupation() {
    return this.$store.getters['occupation/occupation']
  }

  async created() {
    await Promise.all([
      this.$store.dispatch('user/updateWorkerInfo'),
      this.$store.dispatch('occupation/fetch')
    ])
  }
}
